(() => {
  if (window.ulikeCartRetentionInitialized) return;
  window.ulikeCartRetentionInitialized = true;
  const key = 'ulike-cart-retention-shown-at';
  const day = 86400000;
  let lastShown = 0;
  let userClosing = false;
  const cookie = name => document.cookie.split('; ').find(value => value.startsWith(`${name}=`))?.split('=').slice(1).join('=');
  function recentlyShown() {
    try { lastShown = Math.max(lastShown, Number(localStorage.getItem(key)) || 0); } catch (_) {}
    return Date.now() - lastShown < day || cookie('is-cart-popupseen') === '1';
  }
  function showOffer() {
    const drawer = document.getElementById('mini-cart');
    const dialog = document.getElementById('ulike-cart-retention');
    if (!dialog || dialog.open || Number(drawer?.querySelector('[data-retention-cart-count]')?.dataset.retentionCartCount) < 1) return;
    if (!drawer?.querySelector('[data-retention-cart-count]') || recentlyShown() || cookie('subscript-isSubscribe') || location.pathname === '/pages/promotion') return;
    dialog.showModal();
    lastShown = Date.now();
    try { localStorage.setItem(key, String(lastShown)); } catch (_) {}
    document.cookie = 'is-cart-popupseen=1; Max-Age=86400; Path=/; SameSite=Lax; Secure';
  }
  document.addEventListener('click', event => {
    if (event.target.closest('#mini-cart > .drawer__overlay, #mini-cart > .drawer__header [data-action="close"]')) userClosing = true;
    const dialog = document.getElementById('ulike-cart-retention');
    if (event.target.closest('[data-retention-close]')) dialog?.close();
    if (event.target === dialog) {
      const r = dialog.getBoundingClientRect();
      if (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) dialog.close();
    }
  }, true);
  document.addEventListener('keydown', event => {
    if (event.key === 'Escape' && document.getElementById('mini-cart')?.open && !document.getElementById('ulike-cart-retention')?.open) userClosing = true;
  }, true);
  document.addEventListener('openable-element:close', event => {
    if (event.target.id !== 'mini-cart') return;
    const shouldShow = userClosing;
    userClosing = false;
    if (shouldShow) setTimeout(showOffer, 350);
  });
  document.addEventListener('submit', async event => {
    if (!event.target.matches('[data-retention-form]')) return;
    event.preventDefault();
    const form = event.target;
    if (!form.reportValidity()) return;
    const dialog = form.closest('dialog');
    const status = dialog.querySelector('[data-retention-status]');
    const button = form.querySelector('button[type=submit]');
    if (button.disabled) return;
    button.disabled = true;
    status.textContent = '';
    try {
      const response = await fetch('https://api.ulike.com/user/userSubscribe', {
        method: 'POST', credentials: 'include', headers: {'Content-Type': 'application/json'},
        body: JSON.stringify({userEmail: form.elements.email.value.trim(), userPhone: '', since: 'USER_SUBSCRIBE', tags: ['cart-subscript'], siteCode: 'US', language: window.Shopify?.locale || 'en', requestId: crypto.randomUUID()})
      });
      if (!response.ok) throw new Error('Subscription failed');
      const result = await response.json();
      if (result.code !== undefined && String(result.code) !== '0' && String(result.code) !== '200') throw new Error('Subscription rejected');
      document.cookie = 'subscript-isSubscribe=true; Max-Age=2592000; Path=/; SameSite=Lax; Secure';
      form.hidden = true;
      status.textContent = status.dataset.success;
      const code = dialog.dataset.discountCode;
      if (window.discountOnCartProApp?.applyCode) await window.discountOnCartProApp.applyCode(code);
      else window.location.assign(`${window.Shopify?.routes?.root || '/'}discount/${encodeURIComponent(code)}?redirect=${encodeURIComponent('/cart')}`);
    } catch (_) {
      status.textContent = status.dataset.error;
    } finally { button.disabled = false; }
  });
})();
